import { data } from '@tensorflow/tfjs';
import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, switchMap } from 'rxjs';
import { SharedService } from '../../../services/shared.service';
import { SelectionService } from '../../../services/select.service';
import { QueryService } from '../../../services/query.service';
import ExcelJS from 'exceljs';

@Component({
  selector: 'app-formula-salary',
  standalone: false,
  templateUrl: './formula-salary.component.html',
  styleUrl: './formula-salary.component.css'
})
export class FormulaSalaryComponent {
  @ViewChild('employee') employee!: ElementRef;
  searchKeyword$ = new Subject<string>();
  searchSub!: Subscription;
  selectedRoles: any;
  window: Window = window;
  constants: any = {};
  shareObject: any = {
    selectedRows: new Set(),
    checkList: [],
    component: '/formula_salary',
    // addURL: '/user/employee/formula/salary/create',
    // editURL: '/user/employee/formula/salary/edit',
    listURL: '/user/employee/salary',
    // deletedURL: '/user/employee/formula/salary/deleted',
    allowances: [],
    kpiFormulas: [],
    filters: [],

  };
  formHandle!: FormGroup;
  filterForm!: FormGroup
  constructor(
    public sharedService: SharedService,
    public selectionService: SelectionService,
    private queryService: QueryService,
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = { filter: this.sharedService.shareObject.filter.user };
    this.shareObject.active = 'day';
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.id = params['id'];
      }
    })
  }
  ngOnInit(): void {
    this.constants = this.sharedService.env.constants;
    this.shareObject.tabList = [
      { name: this.translate.instant('salary_day'), key: 'day' },
      { name: this.translate.instant('salary_hour'), key: 'hour' },
      { name: this.translate.instant('salary_kpi'), key: 'kpi' }
    ]
    this.shareObject.columns = [
      { name: this.translate.instant('employee_name'), show: true, width: '200px', fixed: true },
      { name: this.translate.instant('salary_basic'), show: true, width: '100px' },
      { name: this.translate.instant('salary_ratio'), show: true, width: '50px' },
      { name: this.translate.instant('salary_timekeeping_standard'), show: true, width: '50px' },
      { name: this.translate.instant('salary_workdays'), show: true, width: '100px' },
      { name: this.translate.instant('salary_component'), show: true, width: '400px', expand: true },
      { name: this.translate.instant('total'), show: true, width: '100px', fixed: true }
    ];
    this.shareObject.timekeepingTypes = this.sharedService.env.timekeepingTypes;
    this.shareObject.data = this.activatedRoute.snapshot.data;
    this.shareObject.formFields = [
      {
        field: 'employee', default: '', valid: [Validators.required],
        filter: (value: any) => {
          if (/^\d+$/.test(value)) {
            return { 'profile.employeeId': parseInt(value) };
          }
          return { 'profile.name': { $regex: value, $options: 'i' } };
        }
      },
      { field: 'ratio', default: 1, valid: [Validators.required, Validators.min(1), Validators.max(100)] },
      { field: 'type', default: 1 },
      { field: 'salary', default: 1 },
      { field: 'salaryAbsence', default: 1 },
      { field: 'status', default: 1 },
      {
        field: 'timekeeping', default: '',
        filter: (value: any) => { return { type: parseInt(value) }; },
        getValue: (v: any, s: any) => {
          if (v == 'empty') return this.translate.instant('timekeeping_empty');
          let name = s.timekeepingTypes.find((e: any) => e.value === parseInt(v))?.name || '';
          return this.translate.instant(name);
        }
      },
      {
        field: 'keyword', default: '',
        filter: (value: any) => {
          if (/^\d+$/.test(value)) {
            return { 'profile.employeeId': parseInt(value) };
          }
          return { 'profile.name': { $regex: value, $options: 'i' } };
        }
      },
      { field: 'limit', default: this.sharedService.env.pageSize[0], filter: (value: any) => value },
      {
        field: 'start', default: '',
        filter: (value: any) => {
          return { start: value }
        },
      },
      {
        field: 'end', default: '',
        filter: (value: any) => {
          return { end: value }
        },
      },
      {
        field: 'employeeGroup', default: '',
        filter: (value: any) => { return { 'profile.employeeGroup': value } },
        getValue: (v: any, s: any) => {
          return s.employeeGroups.find((e: any) => e.id === v)?.name || '';
        }
      },
    ]
    let defineForm = this.sharedService.defineForm(this.shareObject.formFields);
    this.shareObject.filter = defineForm.filter;
    this.formHandle = this.fb.group(defineForm.formHandle);
    this.shareObject.filterForm = this.fb.group(defineForm.filterForm);
    if (this.shareObject.data.type == 'list') {
      this.shareObject.userName = this.translate.instant('select_user');
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['type']) {
        if (this.shareObject.active != params['type']) {
          this.shareObject.active = params['type'];
          this.getBatchData();
        }
      }
      if (params['employeeId']) {
        this.shareObject.filterForm.patchValue({ employee: params['employeeId'] });
      }
    })
    this.getBatchData();
  }
  addAllowance() {
    this.shareObject.allowances.push(this.shareObject.allowanceList.length > 0 ?
      { allowance: this.shareObject.allowanceList[0].id, amount: this.shareObject.allowanceList[0].amount } :
      { allowance: '', amount: 0 });
  }
  changeAllowance(index: any, type: any, value: any) {
    let allowance = this.shareObject.allowances[index];
    allowance[type] = value.target.value;
    if (type == 'allowance') {
      allowance.amount = this.shareObject.allowanceList.find((e: any) => e.id === value.target.value)?.amount || 0;
    }
  }
  removeAllowance(index: number) {
    this.shareObject.allowances.splice(index, 1);
  }
  addKpiFormula() {
    this.shareObject.kpiFormulas.push({ kpiUnit: this.shareObject.kpiUnits[0].id, price: this.shareObject.kpiUnits[0].price });
    console.log(this.shareObject.kpiFormulas);
  }
  changeKpiFormula(index: any, type: any, value: any) {
    let kpiFormula = this.shareObject.kpiFormulas[index];
    kpiFormula[type] = value.target.value;
    if (type == 'kpiUnit') {
      kpiFormula.price = this.shareObject.kpiUnits.find((e: any) => e.id === value.target.value)?.price || 0;
    }
  }
  removeKpiFormula(index: number) {
    this.shareObject.kpiFormulas.splice(index, 1);
  }
  addPayslip(items: any) {
    console.log(`items`, items)
    let payloads = [];
    for (let item of items) {
      let data = {};
      if (item.timekeeping && item.timekeeping.type == this.sharedService.env.constants.TIMEKEEPING.DAY) {
        data = { workOutput: item.totalDayWork || 0, method: this.sharedService.env.constants.TIMEKEEPING.DAY, standard: item.timekeeping.standard || 0 }
      } else if (item.timekeeping && item.timekeeping.type == this.sharedService.env.constants.TIMEKEEPING.HOUR) {
        data = { workOutput: item.workhours || 0, method: this.sharedService.env.constants.TIMEKEEPING.HOUR }
      } else if (item.timekeeping && item.timekeeping.type == this.sharedService.env.constants.TIMEKEEPING.KPI) {
        data = { workOutput: item.kpi || 0, method: this.sharedService.env.constants.TIMEKEEPING.KPI }
      }
      let payload = {
        user: item.id,
        salary: item.totalSalary,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        extension: {
          plus: item.salaryComponentPlus.map((e: any) => ({
            type: { name: e.type.name, type: e.type.type },
            amount: e.amount
          })) || [],
          minus: item.salaryComponentMinus.map((e: any) => ({
            type: { name: e.type.name, type: e.type.type },
            amount: e.amount
          })) || [],
          allowances: item.salaryFormula.allowances.map((e: any) => ({
            name: e.allowance.name,
            amount: e.amount,
          })) || []
        },
        // extension: [...item.salaryComponentPlus, ...item.salaryComponentMinus].map((e: any) => ({
        //   type: { name: e.type.name, type: e.type.type },
        //   amount: e.amount
        // })),
        employee: item.id,
        data: {
          ...data,
          salaryBasic: item.salaryFormula.salary,
          ratio: item.salaryFormula.ratio,
        }
      }
      payloads.push(payload);
    }
    // console.log(payloads);
    // return;
    this.sharedService.callApi('/employee_payslip/add_many', { data: payloads }).subscribe({
      next: (res: any) => {
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('payslip_added'),
          type: 'success',
        });
        this.shareObject.groupDatas.data = this.shareObject.groupDatas.data.map((e: any) => {
          e.data = e.data.map((i: any) => {
            let payslip = res.data.find((p: any) => i.id == p.employee) || null;
            if (payslip) {
              i.payslip = payslip;
            }
            return i;
          });
          e.createdPayslip = e.data.some((i: any) => !i.payslip);
          return e;
        });
        this.shareObject.groupDatas.createdPayslips = this.shareObject.groupDatas.data.some((e: any) => e.createdPayslip);

      },
      error: (err: any) => {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })
  }
  addAllPayslip(items: any) {
    let datas = items.map((e: any) => e.data).flat();
    let payloads = [];
    for (let item of datas) {
      let data = {};
      if (item.timekeeping.type == this.sharedService.env.constants.TIMEKEEPING.DAY) {
        data = { workOutput: item.totalDayWork || 0, method: this.sharedService.env.constants.TIMEKEEPING.DAY, standard: item.timekeeping.standard || 0 }
      } else if (item.timekeeping.type == this.sharedService.env.constants.TIMEKEEPING.HOUR) {
        data = { workOutput: item.workhours || 0, method: this.sharedService.env.constants.TIMEKEEPING.HOUR }
      } else if (item.timekeeping.type == this.sharedService.env.constants.TIMEKEEPING.KPI) {
        data = { workOutput: item.kpi || 0, method: this.sharedService.env.constants.TIMEKEEPING.KPI }
      }
      let payload = {
        user: item.id,
        salary: item.totalSalary,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        extension: {
          plus: item.salaryComponentPlus.map((e: any) => ({
            type: { name: e.type.name, type: e.type.type },
            amount: e.amount
          })) || [],
          minus: item.salaryComponentMinus.map((e: any) => ({
            type: { name: e.type.name, type: e.type.type },
            amount: e.amount
          })) || [],
          allowances: item.salaryFormula.allowances.map((e: any) => ({
            name: e.allowance.name,
            amount: e.amount,
          })) || []
        },
        // extension: [...item.salaryComponentPlus, ...item.salaryComponentMinus].map((e: any) => ({
        //   type: { name: e.type.name, type: e.type.type },
        //   amount: e.amount
        // })),
        employee: item.id,
        data: {
          ...data,
          salaryBasic: item.salaryFormula.salary,
          ratio: item.salaryFormula.ratio,
        }
      }
      payloads.push(payload);
    }
    // console.log(payloads);
    // return;
    this.sharedService.callApi('/employee_payslip/add_many', { data: payloads }).subscribe({
      next: (res: any) => {
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('payslip_added'),
          type: 'success',
        });
        this.shareObject.groupDatas.data = this.shareObject.groupDatas.data.map((e: any) => {
          e.data = e.data.map((i: any) => {
            let payslip = res.data.find((p: any) => i.id == p.employee) || null;
            if (payslip) {
              i.payslip = payslip;
            }
            return i;
          });
          e.createdPayslip = e.data.some((i: any) => !i.payslip);
          return e;
        })
        this.shareObject.groupDatas.createdPayslips = this.shareObject.groupDatas.data.some((e: any) => e.createdPayslip);
      },
      error: (err: any) => {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })
  }
  isSelected(opt: any): boolean {
    return this.shareObject.kpiFormulas.some((v: any) => v?.kpiUnit === opt.id);
  }
  getName(id: any) {
    return this.shareObject.kpiUnitsBak.find((e: any) => e.id === id)?.name || '';
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`${this.shareObject.component}/get_by_user`, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false;
        this.shareObject.employeeGroups = res.employeeGroups;
        this.shareObject.pagination = res.data.pagination;
        let maxIdLength = Math.max(...res.data.data.map((e: any) => String(e.profile?.employeeId).length || 0));
        this.shareObject.users = res.data.data.map((item: any) => {
          item.profile.employeeId = String(item.profile.employeeId).padStart(maxIdLength, '0');
          if (item.timekeeping) {
            item.timekeeping.typeText = this.sharedService.timekeepingTypeText(item.timekeeping.type);
          }
          item.type
          return item;
        })
      },
      error: (err: any) => {
        this.shareObject.isLoading = false;
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })


  }
  getBatchData() {
    this.shareObject.payload = {
      allowanceExtras: this.queryService._allowanceExtra,
      timekeepings: this.queryService._timekeepings,
      salaries: this.queryService._salaries,
      allowances: this.queryService._allowances,
      kpiUnits: this.queryService.kpiUnits,
      groups: this.queryService._groups,
      users: this.queryService._users,
    };
    this.shareObject.filters = this.sharedService.createFilters(this.shareObject).filters;
    console.log(`this.shareObject.filters`, this.shareObject.filters);
    if (this.shareObject.filters && this.shareObject.filters.length > 0) {
      this.shareObject.filters.forEach((item: any) => {
        if (item.key == 'timekeeping') {
          if (item.value == 'empty') {
            this.shareObject.payload.users.data.filter._id = { $nin: "timekeepings.data.$employee" };
          } else {
            this.shareObject.payload.timekeepings.data.filter = item.filter;
            this.shareObject.payload.users.data.filter._id = { $in: "timekeepings.data.$employee" };
          }
        }
        if (item.key == 'employeeGroup') {
          this.shareObject.payload.users.data.filter['profile.employeeGroup'] = item.value;
        }
        if (item.key == 'employee') {
          console.log('item', item);
          this.shareObject.payload.users.data.filter = {
            ...this.shareObject.payload.users.data.filter,
            ...item.filter
          }
        }
        this.shareObject.payload.users.data.limit = item.key == 'limit' ? item.value : this.sharedService.env.pageSize[0];
        this.shareObject.options.limit = item.key == 'limit' ? item.value : this.sharedService.env.pageSize[0];
      });
    }
    this.shareObject.payload.users.data.page = this.shareObject.options.page || 1;
    this.sharedService.getBatch(this.shareObject).subscribe((res: any) => {
      this.shareObject.allowanceExtras = res.responses.allowanceExtras?.data || [];
      this.shareObject.allowanceExtras = this.shareObject.allowanceExtras.concat(this.shareObject.allowanceExtras, this.shareObject.allowanceExtras, this.shareObject.allowanceExtras, this.shareObject.allowanceExtras);

      this.shareObject.users = res.responses.users?.data?.data || [];
      this.shareObject.pagination = res.responses.users?.data?.pagination || {};
      this.shareObject.employeeGroups = res.responses.groups?.data || [];
      this.shareObject.timekeepings = res.responses.timekeepings?.data || [];
      this.shareObject.allowanceList = res.responses.allowances?.data || [];
      this.shareObject.allowanceListBak = res.responses.allowances?.data || [];
      this.shareObject.kpiUnits = res.responses.kpiUnits?.data || [];
      this.shareObject.kpiUnitsBak = res.responses.kpiUnits?.data || [];
      this.shareObject.salaries = res.responses.salaries?.data.map((e: any) => {
        if (e.kpi && e.kpi.length > 0) {
          e.kpi = e.kpi.map((k: any) => {
            k.kpiUnit = this.shareObject.kpiUnits.find((u: any) => u.id === k.kpiUnit) || null;
            return k;
          })
          e.kpiAmount = e.kpi.reduce((x: any, y: any) => x + y.price, 0);
        }
        if (e.allowances && e.allowances.length > 0) {
          e.allowanceAmount = e.allowances.reduce((x: any, y: any) => x + (y.amount || 0), 0);
        }
        return e;
      }) || [];
      this.shareObject.users = this.shareObject.users.map((e: any) => {
        e.timekeeping = this.shareObject.timekeepings.find((t: any) => t.employee === e.id) || null;
        e.salaryFormula = this.shareObject.salaries.find((s: any) => s.employee === e.id) || null;
        if (e.timekeeping) {
          e.timekeeping.typeText = this.sharedService.timekeepingTypeText(e.timekeeping.type);
        }
        if (e.salaryFormula) {
          e.salaryFormula.allowances = e.salaryFormula.allowances.map((item: any) => {
            item.name = this.shareObject.allowanceList.find((a: any) => a.id === item.allowance)?.name || '';
            return item;
          });
        }
        return e;
      });
      //sort theo có salaryFormula trước
      this.shareObject.users.sort((a: any, b: any) => {
        if (a.salaryFormula && !b.salaryFormula) return -1;
        if (!a.salaryFormula && b.salaryFormula) return 1;
        return 0;
      });
    })
  }
  getItem() {
    this.sharedService.getItem(this.shareObject).subscribe((res: any) => {
      this.formHandle.patchValue({
        employee: res.data.employee.id,
        unit_amount: res.data.unit_amount,
        unit_price: res.data.unit_price,
        salary: res.data.salary,
        ratio: res?.data?.ratio,
        hourPay: res.data.hourPay,
        status: res.data.status,
      });
      this.shareObject.allowances = res.data.allowances || [];
      this.shareObject.userName = res.data?.employee?.profile?.name;
      this.shareObject.email = res.data?.employee?.email;
    })
  }
  getItemValue(user: any, type: number = 1) {
    console.log(`user`, user);
    this.shareObject.id = undefined;
    delete this.shareObject.employeeChecked;
    this.shareObject.employeeChecked = user;
    if (!user.timekeeping) {
      this.sharedService.toast({
        title: this.translate.instant('error'),
        message: this.translate.instant('toast_no_timekeeping'),
        type: 'warning',
      });
      return;
    }
    if (type == 0) {
      this.formHandle.reset({
        employee: user.id,
        salary: 0,
        ratio: 100,
        status: 1,
        type: user.timekeeping.type || 1
      });
      this.shareObject.allowances = [];
      this.shareObject.kpiFormulas = [];
    } else {
      this.shareObject.id = user.salaryFormula.id;
      this.formHandle.reset({
        employee: user.id,
        salary: user.salaryFormula.salary || 0,
        salaryAbsence: user.salaryFormula.salaryAbsence || 0,
        ratio: user.salaryFormula.ratio || 100,
        status: user.salaryFormula.status !== undefined ? user.salaryFormula.status : 1,
        type: user.salaryFormula.type || 1,
      });
      this.shareObject.allowances = user.salaryFormula.allowances.map((e: any) => {
        return {
          allowance: e.allowance?.id || e.allowance,
          amount: e.amount || 0
        }
      }) || [];
      console.log(`user`, user);
      this.shareObject.kpiFormulas = user.salaryFormula.kpi.map((e: any) => {
        return {
          kpiUnit: e.kpiUnit.id,
          price: e.price || 0
        }
      }) || [];
      console.log(`this.shareObject.kpiFormulas`, this.shareObject.kpiFormulas);
    }
    this.cdRef.detectChanges();

    // Sửa thành
    setTimeout(() => {
      this.openModal();
    }, 0);

  }
  openModal() {
    this.cdRef.detectChanges(); // Đảm bảo view được cập nhật
    this.sharedService.modalControl('#add-item', true);
  }
  closeModal() {
    this.sharedService.modalControl('#add-item', false);
    this.formHandle.reset();
    this.cdRef.detectChanges();
  }
  handleAfterChange(res: any) {
    console.log(`this.shareObject?.kpiUnits`, this.shareObject?.kpiUnits);
    delete this.shareObject.employeeChecked;
    delete this.shareObject.id;
    this.formHandle.reset();
    this.shareObject.users = this.shareObject.users.map((e: any) => {
      if (e.id == res.data.employee) {
        if (e.salaryFormula) {
          delete e.salaryFormula.allowances;
          delete e.salaryFormula.kpi;
        }
        e.salaryFormula = {
          ...res.data,
          allowances: res.data.allowances && res.data.allowances.length > 0 ? res.data.allowances.map((item: any) => {
            item.name = item.name ? item.name : this.shareObject.allowanceList.find((a: any) => a.id === item.allowance)?.name || '';
            return item;
          }) : [],
          kpi: res.data.kpi && res.data.kpi.length > 0 ? res.data.kpi.map((item: any) => {
            item.kpiUnit = this.shareObject?.kpiUnits?.find((a: any) => a.id === item.kpiUnit) || {};
            return item;
          }) : [],
          allowanceAmount: res.data.allowances && res.data.allowances.length > 0 ? res.data.allowances.reduce((x: any, y: any) => x + (y.amount || 0), 0) : 0,
          kpiAmount: res.data.kpi && res.data.kpi.length > 0 ? res.data.kpi.reduce((x: any, y: any) => x + (y.price || 0), 0) : 0,
        };
      }
      return e;
    })
    console.log(`this.shareObject.users`, this.shareObject.users);
    this.closeModal();
  }
  addItem() {
    let payload: any = {
      employee: this.formHandle.value.employee,
      salary: this.formHandle.value.salary,
      status: this.formHandle.value.status,
      ratio: this.formHandle.value.ratio,
      type: this.formHandle.value.type,
      salaryAbsence: this.formHandle.value.salaryAbsence,
    }
    Object.keys(payload).forEach(key => {
      if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
        delete payload[key];
      }
    });
    if (this.shareObject.allowances.length > 0) {
      payload.allowances = [...this.shareObject.allowances];
    }
    if (this.shareObject.kpiFormulas.length > 0) {
      payload.kpi = [...this.shareObject.kpiFormulas];
    }
    this.shareObject.payload = payload
    this.sharedService.addItem(this.shareObject).subscribe((res: any) => {
      this.handleAfterChange(res);
    })
  }
  updateItem() {
    let payload: any = {
      employee: this.formHandle.value.employee,
      salary: this.formHandle.value.salary,
      ratio: this.formHandle.value.ratio,
      status: this.formHandle.value.status,
      salaryAbsence: this.formHandle.value.salaryAbsence,
    }
    Object.keys(payload).forEach(key => {
      if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
        delete payload[key];
      }
    });
    if (this.shareObject.allowances.length > 0) {
      payload.allowances = [...this.shareObject.allowances];
    }
    if (this.shareObject.kpiFormulas.length > 0) {
      payload.kpi = [...this.shareObject.kpiFormulas];
    }
    console.log(`payload`, payload);
    // return;
    this.shareObject.payload = payload;
    this.sharedService.updateItem(this.shareObject).subscribe((res: any) => {
      this.handleAfterChange(res);
    })
  }
  onSubmit() {
    if (this.formHandle.invalid) {
      console.log('form invalid', this.formHandle.value);
      this.sharedService.toast({
        title: this.translate.instant('title_form_invalid'),
        message: this.translate.instant('message_form_invalid'),
        type: 'danger',
      });
      return;
    }
    if (this.shareObject.id) {
      console.log('update item');
      this.updateItem();
    }
    else {
      this.addItem()
    }
  }
  deleteItem(ids: any) {
    let key = 'salaryFormula';
    this.shareObject.ids = this.selectionService.handleIndextoId(ids, this.shareObject.users, key).map((e: any) => e.id);
    this.sharedService.deleteItem(this.shareObject).subscribe((res: any) => {
      this.shareObject.users = this.shareObject.users.map((e: any) => {
        if (this.shareObject.ids.includes(e[key].id)) {
          delete e[key];
        }
        return e;
      })
      this.selectionService.clearSelection();
    })
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.getBatchData();
  }
  clear() {
    this.shareObject.options = { filter: this.sharedService.shareObject.filter.user, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.shareObject.filters = [];
    this.shareObject.filterForm.reset();
    this.selectionService.clearSelection();
    this.getBatchData();
  }
  filterClear(item: any) {
    console.log('filterClear', item);
    console.log('filters', this.shareObject.filters);
    this.shareObject.filters = this.shareObject.filters.filter((f: any) => f.key != item.key && f.value != item.value);
    this.shareObject.filterForm.patchValue({ [item.key]: null });
    this.onSearch();
  }
  toggleRow(id: any = null, expand: boolean) {
    this.shareObject.showAll = !id && expand
    this.shareObject.groupDatas.data = this.shareObject.groupDatas.data.map((item: any) => {
      item.data = item.data.map((i: any) => {
        if (id) {
          if (i.id == id) {
            i.showDetail = expand;
          }
        } else {
          i.showDetail = expand;
        }
        return i;
      })
      return item;
    });
  }
  onSearch() {
    this.shareObject.filters = this.sharedService.createFilters(this.shareObject).filters;
    console.log('filters', this.shareObject.filters);
    if (this.shareObject.filters && this.shareObject.filters.length > 0) {
      this.shareObject.filters.forEach((item: any) => {
        if (item.key == 'limit') {
          this.shareObject.options.limit = item.value;
          return;
        }
        this.shareObject.options.filter = { ...this.shareObject.options.filter, ...item.filter };
      });
      this.getBatchData();
    }
  }
  filter(key: any, value: any) {
    if (!value) {
      this.filterForm.patchValue({ [key]: null });
      delete this.shareObject[key];
    } else {
      this.shareObject[key] = value;
    }
    this.onSearch();
  }
  onRowClick(event: MouseEvent, index: number) {
    this.selectionService.selectRow(event, index);
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }
  checked(id: any) {
    if (this.shareObject.checkList.includes(id)) {
      this.shareObject.checkList = this.shareObject.checkList.filter((item: any) => item != id);
    } else {
      this.shareObject.checkList.push(id);
    }
    this.shareObject.isCheckAll = this.shareObject.checkList.length == this.shareObject.timesheets.length;
    this.cdRef.detectChanges();
  }
  checkAll() {
    this.shareObject.isCheckAll = !this.shareObject.isCheckAll;
    if (this.shareObject.isCheckAll) {
      this.shareObject.checkList = this.shareObject.timesheets.map((item: any) => item.id);
    } else {
      this.shareObject.checkList = [];
    }
    this.cdRef.detectChanges();
  }
  ngOnDestroy() {
    console.log('ngOnDestroy FormulaSalaryComponent');
    this.shareObject = {};
    console.log(this.shareObject);
    this.sharedService.modalControl('#add-item', false);
  }
  async exportSalaryToExcel(
    groupDatas: any,
    columns: any[],
    timeObj: any,
    fileName: string = 'salary_report.xlsx'
  ) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Salary Report');

    // Lấy tất cả các loại thành phần lương từ dữ liệu
    const allComponents = this.getAllSalaryComponents(groupDatas);

    // Tách thành phần thành 2 nhóm: Plus và Minus
    const plusComponents = allComponents.filter(comp => comp.isPlus);
    const minusComponents = allComponents.filter(comp => !comp.isPlus);

    // Thêm tiêu đề
    const titleRow = worksheet.addRow(['Bảng Lương Chi Tiết Tháng ' + (timeObj.month || '') + ' Năm ' + (timeObj.year || '')]);
    titleRow.font = { bold: true, size: 16 };

    const lastColumn = this.getExcelColumnName(6 + allComponents.length + 4); // 6 cột cơ bản + components + 4 cột tổng
    worksheet.mergeCells(`A1:${lastColumn}1`);
    worksheet.addRow([]);

    // Header row - Các cột cơ bản + từng thành phần lương + các cột tổng riêng
    const headerRow = worksheet.addRow([
      'Nhân viên',
      'Mã NV',
      'Lương cơ bản',
      'Tỷ lệ %',
      'Ngày công chuẩn',
      'Ngày công thực',
      // Các thành phần PLUS
      ...plusComponents.map(comp => comp.name),
      'Tổng phụ cấp',
      'Tổng khoản cộng',
      // Các thành phần MINUS
      ...minusComponents.map(comp => comp.name),
      'Tổng khấu trừ',
      'Tổng khoản trừ',
      'Thực lĩnh'
    ]);
    console.log(`headerRow`, headerRow.values);
    // Style header
    headerRow.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = this.getThinBorder();
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3D3D3' }
      };
    });

    // Merge cells cho các nhóm header
    // if (plusComponents.length > 0) {
    //   // worksheet.mergeCells(
    //   //   this.getExcelColumnName(7) + '3:' +
    //   //   this.getExcelColumnName(6 + plusComponents.length) + '3'
    //   // );

    // }

    // if (minusComponents.length > 0) {
    //   const minusStartCol = 7 + plusComponents.length + 2; // +2 cho 2 cột tổng plus
    //   worksheet.mergeCells(
    //     this.getExcelColumnName(minusStartCol) + '3:' +
    //     this.getExcelColumnName(minusStartCol + minusComponents.length - 1) + '3'
    //   );
    // }

    // Thêm dòng tổng
    this.addTotalRow(worksheet, groupDatas?.total, plusComponents, minusComponents);

    // Thêm dữ liệu theo group
    if (groupDatas?.data?.length > 0) {
      groupDatas.data.forEach((group: any) => {
        this.addGroupRow(worksheet, group, plusComponents, minusComponents);
        this.addEmployeeRows(worksheet, group, plusComponents, minusComponents);
      });
    }

    // Auto fit columns
    this.autoFitColumns(worksheet);

    // Export
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });

  }

  private getAllSalaryComponents(groupDatas: any): any[] {
    const components = new Map();

    if (groupDatas?.data?.length > 0) {
      groupDatas.data.forEach((group: any) => {
        if (group?.data?.length > 0) {
          group.data.forEach((employee: any) => {
            // Allowances (PLUS)
            if (employee?.salaryFormula?.allowances?.length > 0) {
              employee.salaryFormula.allowances.forEach((allowance: any) => {
                components.set(allowance.allowance.name, {
                  name: allowance.allowance.name,
                  type: 'allowance',
                  isPlus: true
                });
              });
            }

            // Salary Component Plus
            if (employee?.salaryComponentPlus?.length > 0) {
              employee.salaryComponentPlus.forEach((component: any) => {
                components.set(component.type.name, {
                  name: component.type.name,
                  type: 'component',
                  isPlus: true
                });
              });
            }

            // Salary Component Minus
            if (employee?.salaryComponentMinus?.length > 0) {
              employee.salaryComponentMinus.forEach((component: any) => {
                components.set(component.type.name, {
                  name: component.type.name,
                  type: 'component',
                  isPlus: false
                });
              });
            }

            // Các thành phần cố định (MINUS)
            components.set('Ứng lương', { name: 'Ứng lương', type: 'advance', isPlus: false });
            components.set('Ký quỹ', { name: 'Ký quỹ', type: 'passbook', isPlus: false });
          });
        }
      });
    }

    return Array.from(components.values());
  }

  private addTotalRow(worksheet: ExcelJS.Worksheet, totalData: any, plusComponents: any[], minusComponents: any[]) {
    const plusValues = plusComponents.map(comp => '');
    const minusValues = minusComponents.map(comp => '');

    const rowData = [
      'TỔNG CỘNG',
      '',
      totalData?.salaryBasic ? this.formatMoney(totalData.salaryBasic) : '0',
      '',
      '',
      totalData?.workDay ? totalData.workDay.toString() : '0',
      // Plus components
      ...plusValues,
      totalData?.totalAllowances ? this.formatMoney(totalData.totalAllowances) : '0',
      totalData?.totalPlus ? this.formatMoney(totalData.totalPlus) : '0',
      // Minus components
      ...minusValues,
      totalData?.totalDeductions ? this.formatMoney(totalData.totalDeductions) : '0',
      totalData?.totalMinus ? this.formatMoney(totalData.totalMinus) : '0',
      totalData?.salary ? this.formatMoney(totalData.salary) : '0'
    ];

    const row = worksheet.addRow(rowData);

    row.eachCell((cell: any, colNumber: any) => {
      cell.border = this.getThinBorder();
      cell.font = { bold: true };

      if (colNumber === 1) {
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
      } else if (colNumber >= 3) {
        cell.alignment = { vertical: 'middle', horizontal: 'right' };
      }

      // Màu cho các cột tổng
      if (colNumber === 6 + plusComponents.length + 1) { // Tổng phụ cấp
        cell.font = { color: { argb: 'FF28A745' }, bold: true };
      } else if (colNumber === 6 + plusComponents.length + 2) { // Tổng cộng (+)
        cell.font = { color: { argb: 'FF28A745' }, bold: true };
      } else if (colNumber === 6 + plusComponents.length + 2 + minusComponents.length + 1) { // Tổng khấu trừ
        cell.font = { color: { argb: 'FFDC3545' }, bold: true };
      } else if (colNumber === 6 + plusComponents.length + 2 + minusComponents.length + 2) { // Tổng cộng (-)
        cell.font = { color: { argb: 'FFDC3545' }, bold: true };
      } else if (colNumber === rowData.length) { // Thực lĩnh
        const color = totalData?.salary > 0 ? 'FF28A745' : totalData?.salary === 0 ? 'FFFFC107' : 'FFDC3545';
        cell.font = { color: { argb: color }, bold: true };
      }
    });
  }

  private addGroupRow(worksheet: ExcelJS.Worksheet, group: any, plusComponents: any[], minusComponents: any[]) {
    const plusValues = plusComponents.map(comp => '');
    const minusValues = minusComponents.map(comp => '');

    const rowData = [
      group?.name || '',
      '',
      group?.total?.salaryBasic ? this.formatMoney(group.total.salaryBasic) : '0',
      '',
      '',
      group?.total?.workDay ? group.total.workDay.toString() : '0',
      // Plus components
      ...plusValues,
      group?.total?.totalAllowances ? this.formatMoney(group.total.totalAllowances) : '0',
      group?.total?.totalPlus ? this.formatMoney(group.total.totalPlus) : '0',
      // Minus components
      ...minusValues,
      group?.total?.totalDeductions ? this.formatMoney(group.total.totalDeductions) : '0',
      group?.total?.totalMinus ? this.formatMoney(group.total.totalMinus) : '0',
      group?.total?.salary ? this.formatMoney(group.total.salary) : '0'
    ];

    const row = worksheet.addRow(rowData);

    row.eachCell((cell: any, colNumber: any) => {
      cell.border = this.getThinBorder();
      cell.font = { bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE9ECEF' }
      };

      if (colNumber === 1) {
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
      } else if (colNumber >= 3) {
        cell.alignment = { vertical: 'middle', horizontal: 'right' };
      }
    });
  }

  private addEmployeeRows(worksheet: ExcelJS.Worksheet, group: any, plusComponents: any[], minusComponents: any[]) {
    if (!group?.data?.length) return;

    group.data.forEach((employee: any) => {
      // Tạo map giá trị cho từng thành phần
      const plusMap = new Map();
      const minusMap = new Map();

      plusComponents.forEach(comp => plusMap.set(comp.name, ''));
      minusComponents.forEach(comp => minusMap.set(comp.name, ''));

      let totalAllowances = 0;
      let totalPlus = 0;
      let totalDeductions = 0;
      let totalMinus = 0;

      // Xử lý allowances (PLUS)
      if (employee?.salaryFormula?.allowances?.length > 0) {
        employee.salaryFormula.allowances.forEach((allowance: any) => {
          plusMap.set(allowance.allowance.name, this.formatMoney(allowance.amount));
          totalAllowances += allowance.amount;
          totalPlus += allowance.amount;
        });
      }

      // Xử lý salaryComponentPlus
      if (employee?.salaryComponentPlus?.length > 0) {
        employee.salaryComponentPlus.forEach((component: any) => {
          plusMap.set(component.type.name, this.formatMoney(component.amount));
          totalPlus += component.amount;
        });
      }

      // Xử lý salaryComponentMinus
      if (employee?.salaryComponentMinus?.length > 0) {
        employee.salaryComponentMinus.forEach((component: any) => {
          minusMap.set(component.type.name, this.formatMoney(component.amount));
          totalDeductions += component.amount;
          totalMinus += component.amount;
        });
      }

      // Xử lý ứng lương
      if (employee?.totalSalaryAdvance > 0) {
        minusMap.set('Ứng lương', this.formatMoney(employee.totalSalaryAdvance));
        totalDeductions += employee.totalSalaryAdvance;
        totalMinus += employee.totalSalaryAdvance;
      }

      // Xử lý sổ tiết kiệm
      if (employee?.totalPassbook > 0) {
        minusMap.set('Sổ tiết kiệm', this.formatMoney(employee.totalPassbook));
        totalDeductions += employee.totalPassbook;
        totalMinus += employee.totalPassbook;
      }

      const plusValues = plusComponents.map(comp => plusMap.get(comp.name) || '');
      const minusValues = minusComponents.map(comp => minusMap.get(comp.name) || '');

      const rowData = [
        employee?.profile?.name || '',
        employee?.profile?.employeeId || '',
        employee?.salaryFormula?.salary ? this.formatMoney(employee.salaryFormula.salary) : '0',
        employee?.salaryFormula?.ratio ? `${employee.salaryFormula.ratio}%` : '',
        employee?.timekeeping?.standard || '',
        employee?.totalDayWork ? employee.totalDayWork.toString() : '0',
        // Plus components và tổng
        ...plusValues,
        totalAllowances > 0 ? this.formatMoney(totalAllowances) : '0',
        totalPlus > 0 ? this.formatMoney(totalPlus) : '0',
        // Minus components và tổng
        ...minusValues,
        totalDeductions > 0 ? this.formatMoney(totalDeductions) : '0',
        totalMinus > 0 ? this.formatMoney(totalMinus) : '0',
        employee?.totalSalary ? this.formatMoney(employee.totalSalary) : '0'
      ];

      const row = worksheet.addRow(rowData);

      row.eachCell((cell: any, colNumber: any) => {
        cell.border = this.getThinBorder();

        if (colNumber === 1 || colNumber === 2) {
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
        } else if (colNumber >= 3) {
          cell.alignment = { vertical: 'middle', horizontal: 'right' };
        }

        // Màu cho các cột tổng plus
        if (colNumber === 6 + plusComponents.length + 1) { // Tổng phụ cấp
          cell.font = { color: { argb: 'FF28A745' }, bold: true };
        } else if (colNumber === 6 + plusComponents.length + 2) { // Tổng cộng (+)
          cell.font = { color: { argb: 'FF28A745' }, bold: true };
        }

        // Màu cho các cột tổng minus
        if (colNumber === 6 + plusComponents.length + 2 + minusComponents.length + 1) { // Tổng khấu trừ
          cell.font = { color: { argb: 'FFDC3545' }, bold: true };
        } else if (colNumber === 6 + plusComponents.length + 2 + minusComponents.length + 2) { // Tổng cộng (-)
          cell.font = { color: { argb: 'FFDC3545' }, bold: true };
        }

        // Màu cho cột thực lĩnh
        if (colNumber === rowData.length) {
          const color = employee?.totalSalary > 0 ? 'FF28A745' : employee?.totalSalary === 0 ? 'FFFFC107' : 'FFDC3545';
          cell.font = { color: { argb: color }, bold: true };
        }

        // Màu cho cột lương cơ bản
        if (colNumber === 3) {
          cell.font = { color: { argb: 'FF28A745' } };
        }
      });
    });
  }

  private formatMoney(amount: number): string {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND'
    }).format(amount);
  }

  private getExcelColumnName(num: number): string {
    let columnName = '';
    let temp = num;

    while (temp > 0) {
      const modulo = (temp - 1) % 26;
      columnName = String.fromCharCode(65 + modulo) + columnName;
      temp = Math.floor((temp - modulo) / 26);
    }

    return columnName;
  }

  private getThinBorder() {
    return {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  }

  private autoFitColumns(worksheet: ExcelJS.Worksheet) {
    worksheet.columns.forEach((column: any) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
        const length = cell.value ? cell.value.toString().length : 10;
        if (length > maxLength) maxLength = length;
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 50);
    });
  }
}


